var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.9626,
    height: 33.9626,
    fill: "url(#pattern0_2001_899)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2001_899",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2001_899",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2001_899",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABH5JREFUWEfdl2toHFUUx/9nJomSLAjW2JhmZ0NtdjZpjPgopcVq1dpmZ5NirAo+kVIC4gMFP0gxtIZKvyhaIoKKxAe+SH007c5GsZgPFbW6tDYl7mxSSWZX20alIrGx6cwcuTOzZaupu1mTfvB82mXuPfd3zzn3f88llGjh2vZLqMz6BJBOyIFKbXi4b7oUV1TKJDEnokTbGdQvfpODllRWHyrFV8kA4WD0ViL6SCzqSLhqZEw/+P8AaAzGmm1yOmWWXvk+Ez98rl3NJgINQe16iXCbZVnPHfnp00y+z7NS0FjX1uBIzj4AlwLYbZj6+rkACCuxwwReCkLaPsXXjR5L/Jzzewbgmtr2yj/K7G8YaHI/MjYaGb13LgDUYKwbxF2eL9prmMvWAlsd919uAVXRdgB41BuDl4xx/aF/K6rZpADYKkWU/f0MxHyIxw0z/sIZAJF3h/gAgDKA9gWqj92UTCZPzx0AsHjxmovKrYokgMsB/G5P8xKRCjcCalB7G4S7ReAdBytGsvrXhY7U7CLgeVMV7U4A7/sp3mZk9C6KLOpYwPKpowDKAXxgmPrthRYX30sBEMlVlei3AF0NYOIy8+QiCoe0TcR41RUU0C0jZvyzeQRARIl1Mvhlr86dNQLgHWLcJfIiB6qqi9X0EiMANbi+FmRl3VInfobUkPYdGC0M7Embensxu/8PKcjVwjCARoD7BcAEGNXM9GI6E3/kvACEtAQYrQD2k6poNgAJhC5jXN92XgCCsddAvBFARgAIRSICNqdMfXuxAGpdawskSWjHn/Y01+fLayEfqqKJot8E4EdxLH4BaAGDe9JmwlPCIi1Sp11hEZ8czSSOFDnFHRZRtD2+KiZFBEQj0cyMD9MZfcNsHJU6Vg1qB0G4UhS+ANgJYAPAvxpmYCHQJ2pi3mxJTbRariAhfDKYn6VIKPowM/X4wrAqbQ6I63jeLKxE7yfQG67wEbWRLwyiSRAnodcY10V1zpupIW0QjBsA/GZXcI13GSnRXQCJ5sNmSW5Oj+1OzQdBJBhbx8QDvu8dhqk/5gI01GnLJQlf+scxnvIUkecSor5+9YUX2JVfieIDMGVZliras/yG5E0A93m1QFvSZrx7LgHCitZLwAPCJ4G7U2Zii/fbt6V16y62SD4AgiIYiHFPKqO/OxcQYUV7koCcyCXlQNXK3KV3VlOqBrVrQfQ5wAEBwcDTaVMXkSgpHU1Nd1RYk5M9BOr0N3KUJGdlamxgLLexfzxMwkrrzQT5Yx9CLJ2wiZ8YNRPiBivaIqG2FYDzPDOWe2nFcXKctUZ24FC+kxlfRuFg6zKCtNNPhxhvM/CW5PDrNdmpLwYxaM1E4haaVbkaEj/onypvGOGQw9QxYsZ/+Pu8cz7N3JqQZNG53ptfKwBOANjHTOMkORPMJBFQA0I9GKsAVOUtcpoIPZN21VPZbN/UTNAF34beEeXNALW5YlWcTRPwniPJ2wtpSkGA3HpCMVmyOohxo9AuEBaKRsZtJQHR1BwHYYgYe8uJdg2ZcRGpgvYXm7P0N0nI+hEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.cdf3de3228910563fe80afdabd2a75da.svg";
export { ForwardRef as ReactComponent };